import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                button: 'enterWebsite'
            }
        }
    }

    init() {
        html.classList.remove('is-loading');

        if(window.isMobile) {
            this.enterWebsite(false);
        } else {
            html.classList.add('has-splash-active');
        }
    }

    enterWebsite(sound = true) {
        if(sound) {
            this.call('loadSound', null, 'AudioManager');
        }

        setTimeout(() => {
            html.classList.remove('has-splash-active');
            html.classList.add('is-first-hit');
            html.classList.add('is-loaded');
            html.classList.add('is-ready');
        }, 100);
    }
}
